"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumericValue = void 0;
var isNumericValue = function (value) { return value !== '' && !isNaN(Number(value)); };
exports.isNumericValue = isNumericValue;
//# sourceMappingURL=isNumericValue.js.map